module.exports = __webpack_public_path__ + "static/media/format-video-outline--gray.b2796e6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/format-video-outline--gray.svg
// module id = 802
// module chunks = 0